<div class="p-8">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-3xl font-bold text-gray-900">Pages</h1>
    <button (click)="addPage()" class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
      Add New Page
    </button>
  </div>
  
  <app-spinner *ngIf="loading"></app-spinner>

  <div *ngIf="!loading" class="bg-white rounded-lg shadow overflow-hidden">
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Slug</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
          <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <tr *ngFor="let page of orderedPages" class="hover:bg-gray-50">
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
            {{ page.name }}
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ page.slug }}</td>
          <td class="px-6 py-4 whitespace-nowrap">
            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full" 
                  [ngClass]="page.hidden ? 'bg-gray-100 text-gray-800' : page.published ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'">
              {{ page.hidden ? 'Hidden' : page.published ? 'Published' : 'Draft' }}
            </span>
          </td>
          <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
            <button (click)="editPage(page._id)" class="text-blue-600 hover:text-blue-900 mr-4">Edit</button>
            <button *ngIf="!isProtectedPage(page)" (click)="confirmDelete(page)" class="text-red-600 hover:text-red-900">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="orderedPages.length === 0" class="p-8 text-center text-gray-500">
      No pages yet. Click "Add New Page" to create one.
    </div>
  </div>
</div>

<app-confirmation-modal
  [show]="showDeleteModal"
  title="Delete Page"
  [message]="'Are you sure you want to delete ' + (pageToDelete?.name || 'this page') + '?'"
  confirmText="Delete"
  (confirm)="deletePage()"
  (cancel)="cancelDelete()">
</app-confirmation-modal>
